import React from "react";
import { SiLine } from "react-icons/si"; // นำเข้าไอคอน LINE จาก React Icons

const Footer = ({ onAddLineClick }) => {
  // const handleAddLineClick = () => {
  //   window.open("https://lin.ee/djFqNgN", "_blank");
  // };

  return (
    <footer className="w-full bg-[#F8F8CA] py-8 flex justify-center items-center">
      {/* ปุ่ม Add Line */}
      <button
        id="add-line-footer"
        onClick={onAddLineClick}
        className="bg-[#06C755] w-40 h-14 md:w-52 md:h-16 xl:w-64 xl:h-20 rounded-lg flex justify-center items-center shadow-md gap-2
  md:hover:bg-[#06A755] cursor-pointer transition duration-300 ease-in-out"
      >
        <div
          className="text-white text-2xl md:text-2xl xl:text-4xl font-bold mt-2 md:mt-0"
          style={{ pointerEvents: "none" }}
        >
          ADD LINE
        </div>
        <SiLine
          className="text-white w-5 h-5 md:w-10 md:h-10 xl:w-12 xl:h-12"
          style={{ pointerEvents: "none" }}
        />
      </button>
    </footer>
  );
};

export default Footer;
